import React, { lazy, useEffect, useRef, useState } from "react";
import "../main/assets/styles/landingBanner.scss";
import { Link, useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";

import { RENTAL_MODULE, TOUR_MODULE } from "Constant/UsreConstant";
import OperatorTourLanding from "Tour-Operator/OperatorTourLanding";

import LandingCard from "../component/landingCards";
// import TitlesCard from "component/TitlesCard";
// import BenefitCard from "component/BenefitCard";
// import LandingSlider from "component/LandingSlider";
// -----------------------------------------

import { useDispatch, useSelector } from "react-redux";
import { fetchLabelsAndPlaceholder } from "Rental-admin/Redux/Actions/HomePageAction";
import get from "lodash.get";
import { isMobileView } from "Constant/common";
const TitlesCard = lazy(() => import("component/TitlesCard"));
const BenefitCard = lazy(() => import("component/BenefitCard"));
const LandingSlider = lazy(() => import("component/LandingSlider"));
const assetPath = process.env.REACT_APP_AZUR_ASSET_PATH;
const bannerVideo = "/main/assets/img/home_page/home_page_banner.mp4";
const TicketBtnIcon = assetPath + "/main/assets/img/icons/ticket.svg";

export default function OperatorLanding() {
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const [isMouseMoving, setIsMouseMoving] = useState(false);
  const { type } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const muted = useRef(null);

  const elements = useSelector((state) => state.homePageReducer.elements);

  useEffect(() => {
    dispatch(fetchLabelsAndPlaceholder());
  }, [dispatch]);
  const destinationDetails = [
    {
      nameElement: "Capetown",
      logoImage: "/main/assets/img/home_page/capetown.webp",
    },
    {
      nameElement: "Delhi",
      logoImage: "/main/assets/img/home_page/delhi.webp",
    },
    {
      nameElement: "France",
      logoImage: "/main/assets/img/home_page/france.webp",
    },
    {
      nameElement: "Leh",
      logoImage: "/main/assets/img/home_page/leh.webp",
    },
    {
      nameElement: "Manali",
      logoImage: "/main/assets/img/home_page/manali.webp",
    },
    {
      nameElement: "Shimla",
      logoImage: "/main/assets/img/home_page/shimla.webp",
    },
  ];
  const ourTopPartners = [
    {
      nameElement: "Vintage Rides",
      logoImage: "/main/assets/img/home_page/vintage_rides.webp",
    },
    {
      nameElement: "Motorcycle Expedition",
      logoImage: "/main/assets/img/home_page/motorcycle_expedition.webp",
    },
    {
      nameElement: "RETZA",
      logoImage: "/main/assets/img/home_page/retza.webp",
    },
    {
      nameElement: "Stonehead Bikes",
      logoImage: "/main/assets/img/home_page/stonehead_bikes.webp",
    },
    {
      nameElement: "Xplorearth",
      logoImage: "/main/assets/img/home_page/xplorearth.webp",
    },
  ];
  const bottomCardData = [
    {
      subHeadingText: "Associate with a Global Brand",
      headingText: "How to become a partner?",
      ctaText: "Explore",
      backImg: "/main/assets/img/home_page/rental_partner.webp",
      mobBackImg: "/main/assets/img/home_page/rental_partner_mobile.webp",
      redirectLink: "/guide/rental-tour-guide",
    },
    {
      subHeadingText: "Associate with a Global Brand",
      headingText: "Start listing",
      ctaText: "Start Now",
      backImg: "/main/assets/img/home_page/start_listing.webp",
      mobBackImg: "/main/assets/img/home_page/start_listing_mobile.webp",
      redirectLink: "/partner/partner-dashboard",
    },
    {
      subHeadingText: "Log in to your account",
      headingText: "Existing user?",
      ctaText: "Login",
      backImg: "/main/assets/img/home_page/existing_user.webp",
      mobBackImg: "/main/assets/img/home_page/existing_user_mobile.webp",
      redirectLink: "/partner/login-account",
    },
  ];
  const partnerWithUs = [
    {
      subHeadingText: "A registered Motorcycle Rental Company",
      headingText: "That has commercially registered Royal Enfield ride(s).",
      logoImage: "/main/assets/img/icons/home_page_icons/rental_company.svg",
    },
    {
      subHeadingText: "A registered Tour Company with commercially",
      headingText:
        "registered Royal Enfield motorcycle(s) that conducts ride tours within India.",
      logoImage: "/main/assets/img/icons/home_page_icons/tour_company.svg",
    },
    {
      subHeadingText: "A registered Tour Company",
      headingText: "without motorcycles that conducts Ride Tours within India.",
      logoImage: "/main/assets/img/icons/home_page_icons/tour_company_c.svg",
    },
  ];
  const benefitDetails = [
    {
      benefitDetailsText: "Associate with a Global Brand",
      logoImage: "/main/assets/img/icons/home_page_icons/global_partner.webp",
    },
    {
      benefitDetailsText:
        "Gain presence in more than 50 countries with 21 website in 11+ languages",
      logoImage: "/main/assets/img/icons/home_page_icons/languages.webp",
    },
    {
      benefitDetailsText: "Your next big sales and marketing channel",
      logoImage: "/main/assets/img/icons/home_page_icons/new_sales.webp",
    },
    {
      benefitDetailsText:
        "Increase your reach to 1.2 million + unique visitors monthly",
      logoImage: "/main/assets/img/icons/home_page_icons/monthly_visitors.webp",
    },
    {
      benefitDetailsText:
        "Track all transactions. Receive secure and timely payments online",
      logoImage:
        "/main/assets/img/icons/home_page_icons/track_transection.webp",
    },
    {
      benefitDetailsText: "Transparent and equal opportunities",
      logoImage:
        "/main/assets/img/icons/home_page_icons/equal_n_transparent.webp",
    },
  ];

  const handleMouseCapture = () => {
    setIsMouseMoving(true);
    setTimeout(() => setIsMouseMoving(false), 2000);
  };
  const togglePlay = () => {
    const video = document.getElementById("bannerVideo");
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };
  const toggleMute = () => {
    const video = document.getElementById("bannerVideo");
    video.muted = !video.muted;
    setIsMuted(video.muted);
  };

  console.log(
    "running",
    `${assetPath}${get(
      elements,
      "bottomCardData.[0].backImg",
      bottomCardData?.[0]?.backImg
    )}`
  );

  return (
    <>
      <div className="landing-page">
        <Link type="button" className="btn add-ticket-btn" to="/add-new-ticket">
          <img src={TicketBtnIcon} alt="icon" />
          Add New Ticket
        </Link>
        <div className="banner-wrapper">
          <video
            id="bannerVideo"
            className="banVideo"
            autoPlay
            muted
            loop
            playsInline
            onMouseMoveCapture={handleMouseCapture}
          >
            <source
              src={`${assetPath}${get(elements, "bannerVideo", bannerVideo)}`}
              type="video/mp4"
            />
          </video>
          {/* <div className="banner-overlay"></div> */}
          <div className={`inner-box ${isMouseMoving ? "hover-image" : ""}`}>
            <button
              type="button"
              className="btn play-button"
              onClick={togglePlay}
            >
              {isPlaying ? (
                <img
                  src={`${assetPath}/main/assets/img/home_page/pause.svg`}
                  alt="play-icon"
                  className="playPause"
                />
              ) : (
                <img
                  src={`${assetPath}/main/assets/img/home_page/play.svg`}
                  alt="pause-icon"
                  className="playPause"
                />
              )}
            </button>
            <button type="button" className="btn muteBtn" onClick={toggleMute}>
              {isMuted ? (
                <img
                  src={`${assetPath}/main/assets/img/home_page/mute.png`}
                  alt="mute-icon"
                  className="muteUnmute"
                />
              ) : (
                <img
                  src={`${assetPath}/main/assets/img/home_page/unmute.png`}
                  alt="unmute-icon"
                  className="muteUnmute"
                />
              )}
            </button>
            {/* <button type="button" className="btn play-button">
                <img src={play} alt="play-icon" className="play" />
              </button> */}
            {/* <h2 className="banner-title">
                {get(
                  elements,
                  "partnerWithUsElement",
                  "Why should you partner with us?"
                )}
              </h2>
              <h1 className="banner-subtitle">
                {get(elements, "royalEnfieldComElement", "royalenfield.com")}
              </h1> */}
          </div>
        </div>
        <div className="container">
          <div className="row bottomCards-wrapper">
            {get(elements, "bottomCardData", bottomCardData).map(
              (item, index) => (
                <div className="col-md-4" key={index}>
                  <LandingCard
                    // title={item?.subHeadingText}
                    subtitle={item?.headingText}
                    button={item?.ctaText}
                    backImg={`${assetPath}${
                      isMobileView() ? item?.mobBackImg : item?.backImg
                    }`}
                    onClick={() => history.push(item?.redirectLink)}
                    priority={true}
                    isLazyLoading={false}
                  />
                </div>
              )
            )}
          </div>
          <div className="row title-card-wrapper">
            <div className="col-md-12">
              <TitlesCard
                title={get(
                  elements,
                  "whoCanPartnerWithUsElement",
                  "Who can Partner with us?"
                )}
                backImg={`${assetPath}${get(
                  elements,
                  isMobileView()
                    ? "whoCanPartnerImageMobile"
                    : "whoCanPartnerImage",
                  isMobileView()
                    ? "/main/assets/img/home_page/who_can_partner_with_us_mobile.jpg"
                    : "/main/assets/img/home_page/who_can_partner_with_us_desktop.webp"
                )}`}
                priority={false}
                isLazyLoading={true}
              />
            </div>
          </div>
          <div className="row partner-card-wrapper">
            {get(elements, "partnerWithUs", partnerWithUs).map(
              (items, index) => (
                <div
                  className={
                    12 / get(elements, "partnerWithUs", partnerWithUs).length <=
                    4
                      ? "col-md-4"
                      : "col-md-6 mb-md-5"
                  }
                  key={index}
                >
                  <LandingCard
                    title={items?.subHeadingText}
                    subtitle={items?.headingText}
                    logo={`${assetPath}${items?.logoImage}`}
                    priority={false}
                    isLazyLoading={true}
                  />
                </div>
              )
            )}
          </div>
          <div className="row title-card-wrapper">
            <div className="col-md-12">
              <TitlesCard
                title={get(
                  elements,
                  "benefitsForThePartnerElement",
                  "Benefits for the Partner"
                )}
                backImg={`${assetPath}${get(
                  elements,
                  isMobileView() ? "benefitsImageMobile" : "benefitsImage",
                  isMobileView()
                    ? "/main/assets/img/home_page/benefits_for_partner_mobile.jpg"
                    : "/main/assets/img/home_page/benefits_for_partner_desktop.jpg"
                )}`}
                priority={false}
                isLazyLoading={true}
              />
            </div>
          </div>
          <div className="row benefit-wrapper mx-0">
            {get(elements, "benefitDetails", benefitDetails).map(
              (items, index) => (
                <div className="col-md-4 px-0" key={index}>
                  <BenefitCard
                    title={items.benefitDetailsText}
                    cardImg={`${assetPath}${items?.logoImage}`}
                    priority={false}
                    isLazyLoading={true}
                  />
                </div>
              )
            )}
          </div>
        </div>
        <div className="destination-slider">
          <LandingSlider
            sliderDetails={get(
              elements,
              "destinationDetails",
              destinationDetails
            )}
            title={get(elements, "destinationPartnerElement", "Destinations")}
            slideToShow={5}
            initialSlide={0}
            arrowLeft={`${assetPath}${get(
              elements,
              "arrowLeftImage",
              "/main/assets/img/icons/home_page_icons/arrow_left.svg"
            )}`}
            arrowRight={`${assetPath}${get(
              elements,
              "arrowRightImage",
              "/main/assets/img/icons/home_page_icons/arrow_right.svg"
            )}`}
            priority={false}
            isLazyLoading={true}
          />
        </div>
        <div className="topPartner-slider">
          <LandingSlider
            sliderDetails={get(elements, "ourTopPartners", ourTopPartners)}
            title={get(elements, "topPartnerElement", "Top Partners")}
            slideToShow={4}
            initialSlide={0}
            arrowLeft={`${assetPath}${get(
              elements,
              "arrowLeftImage",
              "/main/assets/img/icons/home_page_icons/arrow_left.svg"
            )}`}
            arrowRight={`${assetPath}${get(
              elements,
              "arrowRightImage",
              "/main/assets/img/icons/home_page_icons/arrow_right.svg"
            )}`}
            priority={false}
            isLazyLoading={true}
          />
        </div>
      </div>
    </>
  );
}
